<template>
  <el-container style="display: block">
    <headers></headers>
    <el-container
      style="
        min-height: 1000px;
        width: 1300px;
        margin: auto;
      "
    >
      <el-aside width="205px" style="background: #fff">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical-demo"
          text-color="#303133"
          active-text-color="#409EFF"
          :unique-opened="true"
          router
          ref="elMenu"
        >
          <!-- 递归动态菜单 -->
          <myitem></myitem>
        </el-menu>
      </el-aside>

      <div class="order-div">
        <div class="cont-right">
          <div class="common-title">我的订单</div>
          <div class="order-cont">
            <div class="top-search"></div>
            <div class="order-box">
              <el-form
                inline
                :model="formTabel"
                class="demo-form-inline"
                style="text-align: left"
              >
                <el-form-item label="logo名称" prop="title">
                  <el-input
                    v-model="formTabel.title"
                    placeholder="请输入logo名称"
                  />
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="getOrderList() " icon="el-icon-search"
                    ></el-button
                  >
                </el-form-item>
              </el-form>

              <el-table
                :data="orderLsit"
                style="width: 100%"
                
                class="tabelBox"
                :header-cell-style="{
                  color: '#222222',
                  fontWight: 600,
                  textAlign: 'left',
                }"
              >
                <el-table-column prop="create_time" label="下单时间" width="160" />

                <el-table-column prop="pic" label="logo图" width="150">
                  <template v-slot="scope">
                    <img style="border: 1px solid rgb(235, 235, 235);"
                      width="79"
                      height="59"
                      :src="
                        scope.row.pic.replace(
                          'https://logo.aliyun.com/logo/image',
                          'https://s.zaoge.com/logo/get_alilogo.php'
                        )
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="brandName" label="logo名称" />
                <el-table-column prop="price" label="logo价格" width="80" >
                                 <template v-slot="scope">
                    <div>
                      {{scope.row.price/100 }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="mandate" label="类型">
                  <template v-slot="scope">
                    <div>
                      {{ genres[scope.row.genre] }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="mandate" label="授权类型">
                  <template v-slot="scope">
                    <div>
                      {{ mandates[scope.row.mandate] }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="state" label="订单状态">
                  <template v-slot="scope">
                    <div>
                      {{ orderstates[scope.row.state] }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="address" label="操作" width="80">
                  <template v-slot="scope">
                    <div class="moreBtn">
                      <!-- scope.row.state -->
                      <!-- <span v-if="scope.row.state === '2'" @click="toShen(scope.row)"
                  >推送闪电申</span
                > -->
                      <span style="color: cornflowerblue;" @click="toDetail(scope.row.oid)">详情</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import myitem from "../components/myitem"; // 引入递归菜单组件
import headers from "../components/header"; // 引入递归菜单组件
import { getApi, postApi, postApiJson } from "../../utils/request";


export default {
  data() {
    return {
      activeIndex: this.$route.path,
      orderLsit: [],
      formTabel: {
        state: "",
        time: "",
        oid: "",
        title: "",
        city: "",
        sokey: "",
        mandate: "",
        certificateName: "",
      },
      orderstates: {
					"-1": "删除",
					1: "待付款",
					2: "待确认",
					3: "处理中",
					6: "已完成",
				 5: "已取消",
      },
      mandates: {
        1: "可申请商标",
        2: "可买断",
        3: "可商用",
        4: "精选可买断",
        5: "可商用仅卖一次",
      },
      genres: {
        1: "单个logo",
        2: "商用套餐",
      },
    };
  },
  created: function () {
    this.getOrderList();
  },
  methods: {
    // 获取订单列表
    getOrderList() {
      postApiJson("/logoapi/get_order_list", {
        order_genre: 1,
        order_state: "2,3,6",
        keyword: this.formTabel.title,
        limit: "10",
      }).then((res) => {
        console.log(res.data.success);
        if (res.data.success) {
          console.log(res.data.data);
          if (JSON.stringify(res.data.data) == "{}") {
            console.log('dddddadad');
            this.orderLsit =[]
          } else {
             this.orderLsit = res.data.data;
          }
        
        }
      });
    },
    toDetail (oid) {
      	this.$router.push({
					name: 'order_detail',
					query: {oid: oid}
				})
    }
  },

  components: { myitem, headers },
};
</script>


<style scoped>
.el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  margin-top: 10px;
}
.order-div {
  text-align: center;
  width: 100%;
  margin-left: 10px;
  background: #fff;
  padding-bottom: 10px;
  min-height: 600px;
}
.order-box{
  padding: 0 20px;
}
.common-title {
  height: 60px;
  line-height: 60px;
  padding: 0 10px 0 18px;
  border-bottom: 1px solid #ebebeb;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-search {
  margin-top: 10px;
}
.has-gutter {
  background: #909399;
}
.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
   border-right: 0; 
}
</style>



// WEBPACK FOOTER //
// src/views/order.vue